import ReactGA from 'react-ga';

export function initializeReactGA() {
  ReactGA.initialize('UA-139331563-1');
  ReactGA.pageview('/');
}
